import { BackendApiClient } from "../../clients/backend-client";
import { AuthorizedUser } from "./models/auth";

export class AuthRepository {
    private _client: BackendApiClient;

    constructor() {
        this._client = new BackendApiClient('/api/auth');
    }

    async getAuthorized(): Promise<AuthorizedUser> {
        return await this._client.getSimple<AuthorizedUser>("authorized");
    }

    async logout(): Promise<{}> {
        return await this._client.getText("logout");
    }
}